export function HeroSection() {
  return (
    <div className="text-center" style={{ marginTop: 56 }}>
      <h1
        className="font-bold text-foreground mx-auto"
        style={{
          maxWidth: 760,
          fontSize: 56,
          lineHeight: "64px",
          marginBottom: 16,
        }}
      >
        Daily AI Ideas
      </h1>
      <p
        className="text-muted-foreground mx-auto"
        style={{
          maxWidth: 640,
          fontSize: 20,
          lineHeight: "32px",
          marginBottom: 40,
        }}
      >
        Curated insights and AI-powered ideas for your team.
      </p>
      <div
        className="mx-auto bg-border"
        style={{ width: 120, height: 1, marginBottom: 40 }}
      />
    </div>
  );
}
